import { Button } from "./Button";
import { PROJECT_REPO_URL } from "../../app/projectLinks";

type HeaderProps = {
  theme: "light" | "dark";
  onToggleTheme: () => void;
};

const SunIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export function Header({ theme, onToggleTheme }: HeaderProps) {
  return (
    <header className="site-header">
      <div className="container header-inner">
        <a className="brand" href="#markdown" aria-label="Serverless Converter home">
          <span className="brand-mark">SC</span>
          <span className="brand-copy">
            <span className="brand-name">Serverless Converter</span>
            <span className="brand-tagline">Local · Private · Zero backend</span>
          </span>
        </a>
        <nav className="header-actions" aria-label="Header actions">
          <a className="text-link" href={PROJECT_REPO_URL} target="_blank" rel="noreferrer">
            GitHub
          </a>
          <Button
            type="button"
            variant="ghost"
            className="theme-button"
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            onClick={onToggleTheme}
            icon={theme === "dark" ? <SunIcon /> : <MoonIcon />}
          >
            {theme === "dark" ? "Light" : "Dark"}
          </Button>
        </nav>
      </div>
    </header>
  );
}
